import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function quoteReducer(
  state = initialState.quote ? initialState.quote : [],
  action
) {
  switch (action.type) {
    case types.QUOTE_SUCCESS:
      return action.quote;
    case types.QUOTE_FAILED:
      return action.error;
    default:
      return state;
  }
}
